<ag-shr-media-gallery
  [mediaItems]="mediaItems"
  [multipleSelection]="false"
  [allowActions]="false"
  [allowZoomIn]="false"
  (selectedItemsChange)="selectedItemsChange($event)"
></ag-shr-media-gallery>
